var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201.45 200.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #eccb00;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #110bff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m100,0c-51.14,0-47.95,22.18-47.95,22.18l.06,22.98h48.8v6.89H32.72S0,48.33,0,99.94s28.56,49.77,28.56,49.77h17.05v-23.95s-.92-28.56,28.11-28.56h48.4s27.2.44,27.2-26.28V26.74S153.44,0,100,0Zm-26.91,15.45c4.85,0,8.78,3.93,8.78,8.78s-3.93,8.78-8.78,8.78c-4.84,0-8.77-3.91-8.78-8.76,0,0,0-.02,0-.03,0-4.85,3.93-8.78,8.78-8.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.45,200.4c51.14,0,47.95-22.18,47.95-22.18l-.06-22.98h-48.8v-6.89h68.19s32.72,3.71,32.72-47.89-28.56-49.77-28.56-49.77h-17.05v23.94s.92,28.56-28.11,28.56h-48.4s-27.2-.44-27.2,26.28v44.19s-4.13,26.74,49.31,26.74Zm26.91-15.45c-4.84,0-8.77-3.91-8.78-8.76,0,0,0-.02,0-.03,0-4.85,3.93-8.78,8.78-8.78s8.78,3.92,8.78,8.78-3.93,8.78-8.78,8.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.2351071a7392204561534d9201f8c2ed.svg";
export { ForwardRef as ReactComponent };